// src/App.jsx
import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./styles.css";
import { FaArrowUp } from "react-icons/fa";
import Footer from "./components/Footer/Footer";
import CookieConsent from "./components/cookieConsent/CookieConsent";
import { GoogleOAuthProvider } from "@react-oauth/google";
import BreadcrumbsHelmet from "./components/Seo/BreadcrumbsHelmet";

// Sivun komponentit
import Navbar from "./components/Navbar/Navbar";
import Home from "./Pages/Home/Home";
import Rental from "./Pages/Rental/Rental";
import AboutUs from "./Pages/AboutUs/AboutUs";
import UKK from "./Pages/UKK/UKK";
import Contactpage from "./Pages/Contactpage/Contactpage";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import NotFound from "./Pages/NotFound/NotFound";
import DetailedServices from "./Pages/DetailedServices/DetailedServices";
import ProductPage from "./Pages/ProductPage/ProductPage";
import RentalTerms from "./Pages/RentalTerms/RentalTerms";
import { useContext } from "react";
import ThemeContext from "./context/ThemeContext";

function App() {
  const location = useLocation();
const { theme, setTheme } = useContext(ThemeContext);

  // Scroll-bar & nappi
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.body.scrollHeight - window.innerHeight;
      const progress = (scrollTop / scrollHeight) * 100;
      const bar = document.getElementById("bar");
      if (bar) bar.style.width = `${progress}%`;
      setShowButton(scrollTop > 500);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // AOS
  useEffect(() => {
    AOS.init({ offset: 100, duration: 400, easing: "ease-in-sine", delay: 0 });
  }, []);

  useEffect(() => {
    window.openCookieSettings = () => {
      localStorage.removeItem("cookieConsent");
      window.location.reload();
    };
  }, []);

  // Seurataan modalin tilaa sessionStoragesta
  const [modalOpen, setModalOpen] = useState(
    () => sessionStorage.getItem("isModalOpen") === "true"
  );
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "isModalOpen") {
        setModalOpen(sessionStorage.getItem("isModalOpen") === "true");
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // Navbar piilotetaan vain /esiintyjat + modal auki
  const hideNavbar = location.pathname === "/esiintyjat" && modalOpen;

  return (
    <>
      <BreadcrumbsHelmet />
      {/* Navbar */}
      {!hideNavbar && <Navbar theme={theme} setTheme={setTheme} />}

      {/* Toast */}
      <ToastContainer
        position="top-center"
        toastClassName={() =>
          "relative flex items-center justify-center p-4 mx-auto max-w-sm dark:bg-violet bg-lightbg font-customFont1 text-center text-darkest dark:text-primary dark:text-shadow-lg font-normal rounded-lg animate-toast-in"
        }
        style={{
          filter: "drop-shadow(5px 5px 10px #000000)",
          marginTop: "4rem",
        }}

        autoClose={6000}
        closeButton={({ closeToast }) => (
          <button
            onClick={closeToast}
            className="absolute top-2 right-2 text-red-500 hover:text-red-700"
          >
            ✖
          </button>
        )}
        progressClassName="bg-primary"
      />

        <div className="min-h-screen">

        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
         
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vuokrattavat" element={<Rental />} />
              <Route path="/UKK" element={<UKK />} />
              <Route path="/meista" element={<AboutUs />} />
              <Route path="/tee-varaus" element={<Contactpage />} />
              <Route path="/tietosuojalausunto" element={<PrivacyPolicy />} />
              <Route path="/tuote/:slug" element={<ProductPage />} />
              <Route path="/palvelut" element={<DetailedServices />} />
              <Route path="/vuokrausehdot" element={<RentalTerms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
       
        </GoogleOAuthProvider>
      </div>

      {/* Progress‐bar & scroll‐top */}
      <div className="progress_wrapper">
        <div className="progress_bar" id="bar"></div>
      </div>
      <FaArrowUp
        className={showButton ? "showButton" : "hidden"}
        onClick={scrollToTop}
      />

      <Footer />
      <CookieConsent />

      <div id="tarteaucitron" />
    </>
  );
}

export default App;
